<div class="ui {{loadingIsActive ? 'active' : ''}} dimmer">
  <div class="ui text large loader">Loading</div>
</div>
<table *ngFor="let cashout of this.tournamentsService.CashoutDetailList_Terminal;let i = index;"
       id="cashoutdetail_table">
  <tr class="cashoutdetail_tr"
      style="background-color:#948c89">
    <td><span style="font-weight: bold;">{{"BETTING_SLIP_DETAILS" | t}}</span>
      <button class="large ui  button "
              style="height:30px;background-color:black;color:white;float:right;"
              routerLink="/LiveBets"><i class="reply icon"
                                        style="position:relative;bottom:5px"></i><span style="position:relative;bottom:5px">{{"Back" | t}}</span>
      </button>
    </td>

  </tr>

  <tr class="cashoutdetail_tr"
      style="background-color:gainsboro">
    <td><span>{{"Betting_slip_number" | t}}</span><span style="float:right;font-weight:bold">{{cashout?.ID}}</span></td>

  </tr>
  <tr class="cashoutdetail_tr"
      style="background-color:#cbc4be">
    <td><span>{{"Date" | t}}</span><span style="float:right;font-weight:bold">{{cashout?.Date}}</span></td>

  </tr>
  <tr class="cashoutdetail_tr"
      style="background-color:gainsboro">
    <td><span>{{"Status" | t}}</span>
      <button class="circular ui icon mini basic button"
              style="background:transparent!important;float:right;position:relative;bottom:0px;left:2px;">
        <i class="info icon"></i>
      </button>
      <div [style.backgroundColor]="cashout?.StateColor"
           style="height:30px;float:right;min-width:26%;text-align:center;border-radius:5px">
        <span style="position:relative;top:3px">{{this._translate.getT(cashout?.Status)}}</span></div>
    </td>

  </tr>
  <tr class="cashoutdetail_tr"
      style="background-color:#cbc4be">
    <td><span>{{"Type_Of_Bets" | t}}</span><span style="float:right;font-weight:bold">{{cashout?.Type}}</span></td>

  </tr>
  <tr class="cashoutdetail_tr"
      style="background-color:gainsboro">
    <td><span>{{"Number_Of_Bets_" | t}}</span><span style="float:right;font-weight:bold">{{cashout?.OddCount}}</span>
    </td>

  </tr>
  <tr class="cashoutdetail_tr"
      style="background-color:#cbc4be">
    <td><span>{{"Total_Amounts" | t}}</span><span style="float:right;font-weight:bold">{{cashout?.TotalAmount}}</span>
    </td>

  </tr>
  <tr class="cashoutdetail_tr"
      style="background-color:gainsboro">
    <td>
      <span style="font-weight:bold">{{"Tax" | t}}</span><span style="float:right;font-weight:bold">{{cashout?.TaxAmount}}</span>
    </td>

  </tr>
  <tr class="cashoutdetail_tr"
      style="background-color:#cbc4be">
    <td>
      <span style="font-weight:bold">{{"Current_Stake" | t}}</span><span style="float:right;font-weight:bold;">{{cashout?.TotalStake}}</span>
    </td>

  </tr>
  <tr class="cashoutdetail_tr"
      style="background-color:gainsboro">
    <td>
      <span style="font-weight:bold">{{"Stake_per_Bet" | t}}</span><span style="float:right;font-weight:bold;">{{cashout?.StakePerBet}}</span>
    </td>

  </tr>
  <tr class="cashoutdetail_tr"
      style="background-color:#cbc4be">
    <td>
      <span style="font-weight:bold">{{"Possible_winnings" | t}}</span><span style="float:right;font-weight:bold;">{{cashout?.MaxGain}}</span>
    </td>

  </tr>
  <tr class="cashoutdetail_tr"
      style="background-color:gainsboro; font-size: 20px;
      color: mediumseagreen;">
    <td>
      <span style="font-weight:bold">{{"Already_won" | t}}</span><span style="float:right;font-weight:bold;">{{cashout?.Winnings.toFixed(2)}}</span>
    </td>

  </tr>
  <tr *ngIf="(cashout?.StateId == 1 ||cashout?.StateId == 3 ||cashout?.StateId == 6)&&(cashout.IsPayout==false)">
    <td>
      <div style="background-color:#464040;height: 66px;padding: 8px;">
        <div *ngIf="this.tournamentsService.confirmMessageActive==0 && cashout?.StateId == 1 "
             style="background-color:white;width:100%;border-radius:4px;height:50px;text-align:center;padding-right:10px">
          <span style="position:relative;top:14px;font-size:15px;font-weight:bold;"></span>
          <span *ngIf="this.TimerMessageActive==1"
                style="float:right;position:relative;top:12px;font-weight:bold;color:orange;font-size:28px;">{{this.CashOutTimerCounter}}</span>
        </div>
        <div *ngIf="this.tournamentsService.confirmMessageActive==1 && cashout?.StateId == 1 "
             style="background-color:orange;width:100%;border-radius:4px;height:50px;text-align:center">
          <span *ngIf="this.tournamentsService.cashoutMessageTerminalActive==0"
                style="position:relative;top:12px;color:white;font-size:28px">{{this.tournamentsService.confirmTicketCounter}}</span>
          <span *ngIf="this.tournamentsService.cashoutMessageTerminalActive==1"
                style="position:relative;top:14px;color:white;font-size:18px;font-weight:bold;">{{this.tournamentsService.cashoutmessageTerminal}}</span>
        </div>
        <div *ngIf="(cashout?.StateId == 3 ||cashout?.StateId == 6)&& (this.tournamentsService.confirmMessageActivePayout==0 )"
             style="background-color:white;width:100%;border-radius:4px;height:50px;text-align:center;padding-right:10px">

          <span *ngIf="this.PayoutTimerMessageActive==1"
                style="position:relative;top:12px;font-weight:bold;color:orange;font-size:28px;">{{this.PayOutTimerCounter}}</span>
        </div>
        <div *ngIf="(cashout?.StateId == 3 ||cashout?.StateId == 6) && (this.tournamentsService.confirmMessageActivePayout==1)"
             style="background-color:orange;width:100%;border-radius:4px;height:50px;text-align:center">
          <span style="position:relative;top:12px;color:white;font-size:28px">{{this.tournamentsService.confirmTicketCounterPayout}}</span>

        </div>

      </div>
    </td>
  </tr>


  <ng-container *ngIf="this.tournamentsService.TicketKeyboardModalIsActive">

    <tr *ngIf="(cashout?.StateId == 3 ||cashout?.StateId == 6)&&(cashout.IsPayout==false)&&(this.tournamentsService.payOutButtonClick == 0)"
        class="cashoutdetail_tr">
      <td>
        <button class="positive ui button"
                style="width:100%;height:60px;font-size:20px;"
                (click)="TicketChecker_Payout(cashout?.Winnings)">
          <span>{{"PAYOUT" | t}}</span>:<span>{{cashout?.Winnings.toFixed(2)}}</span></button>
      </td>
    </tr>

    <tr *ngIf="cashout?.StateId == 1 && this.tournamentsService.cashOutButtonClick == 0 &&
    (this.coreService.CustomerCardIsActive==0 || (
    cashout?.SourceId == 4 ||
    cashout?.SourceId == 5 ||
    cashout?.SourceId == 1 ||
    cashout?.SourceId == 2))"
        class="cashoutdetail_tr">
        <td>


          <div class="cashout">
  
            <div class="row">
              <span class="label">{{'CashOut' | t }}</span>
              <span class="value green">{{getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0])}}</span>
            </div>
          
  
          
            <div class="quick-buttons">
                <button type="button" class="chip" [class.active]="percent===25" (click)="setPercent(25,getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0]))">%25</button>
                <button type="button" class="chip " [class.active]="percent===50" (click)="setPercent(50,getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0]))">%50</button>
              <button type="button" class="chip" [class.active]="percent===75" (click)="setPercent(75,getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0]))">%75</button>
              <button type="button" class="chip" [class.active]="percent===100" (click)="setPercent(100,getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0]))">%100</button> 
            </div>
          
            <div class="row strong">
              <span class="label">{{'Paid_Now' | t}}</span>
              <span class="value green">
                {{(getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0])*(percent/100))?.toFixed(2)}}
            </span>
            </div>
          
            <div class="row strong">
              <span class="label">{{'Remaining_stake' | t}}</span>
              <span class="value">{{(getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0])-getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0])*(percent/100))?.toFixed(2)}}              </span>
            </div>
          </div>
          <button id="cashoutValueButton"
          class="positive ui {{getcashOutSendVisibilty()}} button"
          [disabled]="!this._uiHelper.terminalConfig.IsCashout"
          style="    width: 100%;
  height: 60px;
  font-size: 20px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  "
          (click)="TicketChecker_Cashout( (getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0])*(percent/100))?.toFixed(2))">
    <span style="text-shadow: 2px 7px 5px rgba(0,0,0,0.3), 0px -4px 10px rgba(255,255,255,0.3);">{{"CASHOUT" | t}}</span>:
    <span class="wrappercashout" style="text-shadow: 2px 7px 5px rgba(0,0,0,0.3), 0px -4px 10px rgba(255,255,255,0.3);">{{(getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0]) * percent / 100)?.toFixed(2)}}</span>
  
  
  </button>
        </td>
    </tr>

  </ng-container>

  <ng-container *ngIf="!this.tournamentsService.TicketKeyboardModalIsActive">
    <!-- Kart Takılı - Cashout   -->
    <tr *ngIf="cashout?.StateId == 1 && this.tournamentsService.cashOutButtonClick == 0 &&
    this.coreService.CustomerCardIsActive == 1 && (
    cashout?.SourceId == 4 ||
    cashout?.SourceId == 5 ||
    cashout?.SourceId == 1 ||
    cashout?.SourceId == 2)"
        class="cashoutdetail_tr">
        <td>


          <div class="cashout">
  
            <div class="row">
              <span class="label">{{'CashOut' | t }}</span>
              <span class="value green"> {{getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0])}}</span>
            </div>
          
  
          
            <div class="quick-buttons">
                <button type="button" class="chip" [class.active]="percent===25" (click)="setPercent(25,getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0]))">%25</button>
                <button type="button" class="chip " [class.active]="percent===50" (click)="setPercent(50,getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0]))">%50</button>
              <button type="button" class="chip" [class.active]="percent===75" (click)="setPercent(75,getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0]))">%75</button>
              <button type="button" class="chip" [class.active]="percent===100" (click)="setPercent(100,getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0]))">%100</button> 
            </div>
          
            <div class="row strong">
              <span class="label">{{'Paid_Now' | t}}</span>
              <span class="value green">
                {{(getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0])*(percent/100))?.toFixed(2)}}
            </span>
            </div>
          
            <div class="row strong">
              <span class="label">{{'Remaining_stake' | t}}</span>
              <span class="value">              {{(getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0])-getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0])*(percent/100))?.toFixed(2)}}
              </span>
            </div>
          </div>
          <button id="cashoutValueButton"
          class="positive ui {{getcashOutSendVisibilty()}} button"
          [disabled]="!this._uiHelper.terminalConfig.IsCashout"
          style="    width: 100%;
  height: 60px;
  font-size: 20px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  "
        (click)="CashOutPayOpenBets((getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0]) * percent / 100)?.toFixed(2))">
    <span style="text-shadow: 2px 7px 5px rgba(0,0,0,0.3), 0px -4px 10px rgba(255,255,255,0.3);">{{"CASHOUT" | t}}</span>:
    <span class="wrappercashout" style="text-shadow: 2px 7px 5px rgba(0,0,0,0.3), 0px -4px 10px rgba(255,255,255,0.3);"> {{(getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0])*(percent/100))?.toFixed(2)}}</span>
  
  
  </button>
        </td>
    </tr>
    <!-- Kart Takılı - Cashout   -->
    <!-- Kupon okutulduğunda - Kart Takılı değil    -->
    <tr *ngIf="cashout?.StateId == 1 && this.tournamentsService.cashOutButtonClick == 0 &&
    (this.coreService.CustomerCardIsActive == 0 && (
    cashout?.SourceId == 4 ||
    cashout?.SourceId == 5 ||
    cashout?.SourceId == 1 ||
    cashout?.SourceId == 2))"
        class="cashoutdetail_tr">
        <td>


          <div class="cashout">
  
            <div class="row">
              <span class="label">{{'CashOut' | t }}</span>
              <span class="value green">{{getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0])}}</span>
            </div>
          
  
          
            <div class="quick-buttons">
                <button type="button" class="chip" [class.active]="percent===25" (click)="setPercent(25,getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0]))">%25</button>
                <button type="button" class="chip " [class.active]="percent===50" (click)="setPercent(50,getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0]))">%50</button>
              <button type="button" class="chip" [class.active]="percent===75" (click)="setPercent(75,getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0]))">%75</button>
              <button type="button" class="chip" [class.active]="percent===100" (click)="setPercent(100,getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0]))">%100</button> 
            </div>
          
            <div class="row strong">
              <span class="label">{{'Paid_Now' | t}}</span>
              <span class="value green">
                {{(getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0])*(percent/100))?.toFixed(2)}}
            </span>
            </div>
          
            <div class="row strong">
              <span class="label">{{'Remaining_stake' | t}}</span>
              <span class="value">              {{(getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0])-getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0])*(percent/100))?.toFixed(2)}}
              </span>
            </div>
          </div>
          <button id="cashoutValueButton"
          class="positive ui {{getcashOutSendVisibilty()}} button"
          [disabled]="!this._uiHelper.terminalConfig.IsCashout"
          style="    width: 100%;
  height: 60px;
  font-size: 20px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  "
          (click)="CashOutPay((getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0]) * percent / 100)?.toFixed(2))">
    <span style="text-shadow: 2px 7px 5px rgba(0,0,0,0.3), 0px -4px 10px rgba(255,255,255,0.3);">{{"CASHOUT" | t}}</span>:
    <span class="wrappercashout" style="text-shadow: 2px 7px 5px rgba(0,0,0,0.3), 0px -4px 10px rgba(255,255,255,0.3);"> {{(getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0])*(percent/100))?.toFixed(2)}}</span>
  
  
  </button>
        </td>
    </tr>
    <!-- Kupon okutulduğunda - Kart Takılı değil    -->
    <!-- Onay için İkinci kez kuponu okutun yazısı-->
    <tr *ngIf="cashout?.StateId == 1 && this.tournamentsService.cashOutButtonClick == 1 && this.coreService.CustomerCardIsActive==0"
        class="cashoutdetail_tr">
      <td>
        <button id="cashoutValueButton"
                class="ui {{getcashOutSendVisibilty()}} button"
                style="    width: 100%;
    background-color: orange;
    height: 60px;
    font-size: 18px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
">
          <span>{{"Scan_Bet_Ticket_to_Confirm" | t}}</span>:
          <span> {{(getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0])*(percent/100))?.toFixed(2)}} </span>
        </button>
      </td>
    </tr>
    <!-- Onay için İkinci kez kuponu okutun yazısı-->

    <tr
      *ngIf="(cashout?.StateId == 3 ||cashout?.StateId == 6)&&(cashout.IsPayout==false)&&(this.tournamentsService.payOutButtonClick == 0) && cashout?.SourceId != 6"
        class="cashoutdetail_tr">
      <td>
        <button class="positive ui button"
                style="width:100%;height:60px;font-size:20px;"
                (click)="WithdrawPay(cashout?.Winnings)">
          <span>{{"PAYOUT" | t}}</span>:<span>{{cashout?.Winnings.toFixed(2)}}</span>
        </button>
      </td>

    </tr>
    <tr *ngIf="(cashout?.StateId == 3 ||cashout?.StateId == 6)&&(cashout.IsPayout==false)&&(this.tournamentsService.payOutButtonClick == 1)"
        class="cashoutdetail_tr">
      <td>
        <button class="ui button"
                style="width:100%;background-color:orange;height:60px;font-size:18px"
                (click)="WithdrawPayAcceptTry(cashout?.Winnings)">
          <span>{{"Scan_Bet_Ticket_to_Confirm" | t}}</span>:<span> {{(getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0])*(percent/100))?.toFixed(2)}}</span>
        </button>
      </td>

    </tr>
  </ng-container>


  <!--<tr class="cashoutdetail_tr">-->
  <!--<td><button class="ui button" style="width:60%;background-color:orange" (click)="RestoreBettingSlip()" routerLink="/LiveBets"><span>{{"Restore_Betting_Slip" | t}}</span></button><button class="ui button" style="background-color:black;color:white;width:37%" (click)="CashoutDetail_Print()"><span>{{"Print" | t}}</span></button></td>-->

  <!--<td><button class="ui button" style="width:60%;background-color:orange;height:45px" (click)="RestoreBettingSlip()"  routerLink="/LiveBets"><span>{{"Restore_Betting_Slip" | t}}</span></button><button class="ui button" style="background-color:black;color:white;width:37%;height:45px"><span>{{"Print" | t}}</span></button></td>

</tr>-->

</table>
<div style="position: absolute; bottom: 0;width: 99%;height:87px;background: gainsboro;">
  <div style="height: 73px; background: white;position: relative;top: 12px;width: 97%;left:8px">
    <!--<td><button class="ui button" style="width:60%;background-color:orange" (click)="RestoreBettingSlip()" routerLink="/LiveBets"><span>{{"Restore_Betting_Slip" | t}}</span></button><button class="ui button" style="background-color:black;color:white;width:37%" (click)="CashoutDetail_Print()"><span>{{"Print" | t}}</span></button></td>-->

    <button class="ui button"
            style="width:50%;background-color:orange;height:60px;position: relative;top: 10px;left:2px"
            (click)="RestoreBettingSlip()"
            routerLink="/LiveBets"><span>{{"Restore_Betting_Slip" | t}}</span></button>
    <button class="ui button"
            (click)="DuplicateBettingSlip()"
            style="background-color:black;color:white;width:48%;height:60px;position: relative;top: 10px;left:2px">
      <span>{{"Print" | t}}</span></button>
  </div>
</div>
<div id="cashoutdetail_modalcashout"
     class="ui modal">

  <div class="content">
    <span style="font-weight:bold;">{{"CASHOUT_WINNINGS_OF" | t}} </span><span> {{this.CashOutValueSend}} €?</span>
  </div>
  <div class="actions"
       style="text-align:center">
    <button class="ui active button terminalButton"
            (click)="CashoutValueOk()"><span>{{"Ok" | t}}</span></button>
    <button class="ui active button terminalButton"
            (click)="CashoutModalExit()"><span>{{"Cancel" | t}}</span></button>
  </div>
</div>
<div id="cashoutdetail_modalwithdraw"
     class="ui modal">

  <div class="content">
    <span style="font-weight:bold;">{{"PAYAOUT_WINNINGS_OF" | t}}  </span><span> {{this.WithdrawValueSend}} €?</span>
  </div>
  <div class="actions"
       style="text-align:center">
    <button class="ui active button terminalButton"
            (click)="WithdrawValueOk()"><span>{{"Ok" | t}}</span></button>
    <button class="ui active button terminalButton"
            (click)="WithdrawModalExit()"><span>{{"Cancel" | t}}</span></button>
  </div>
</div>
<div id="cashoutdetail_creditvoucher"
     class="ui modal"
     style="width: 710px;height:310px">
  <button class="circular ui icon button"
          (click)="ExitCreditVoucherModal()"
          style="float:right;background-color: white;border: 1px solid;margin-top:1px;">
    <i class="remove link icon"></i>
  </button>
  <br/><br/>

  <!--<div><button class="ui circular button" (click)="ExitCreditVoucherModal()" style="float:right;">X</button></div><br /><br />-->
  <div class="content"
       style="text-align:center">
    <img src="../../../Images/creditvoucher.png"/>
  </div>
  <br/>
  <div style="text-align:center;font-size:18px;font-weight:bold;font-family:serif">
    <span>{{this.tournamentsService.translations["Bet_successfully_redeemed._Your_balance_has_been_updated"]}} </span>
  </div>
  <br/>

  <div style="text-align:center">
    <button class="ui button"
            style="background-color:orange;width:250px"
            (click)="SubmitNewBet()"><span>{{"Submit_New_Bet" | t}}</span></button>
  </div>
  <br/>
  <div style="text-align:center;font-size:18px;font-weight:bold;font-family:serif">
    <span>{{this.tournamentsService.translations["You_can_withdraw_your_credit_balance_by_pressing_on_'Credit_Voucher'_in_the_upper_right_corner_and_retrieve_your_credit_voucher._that_can_be_redeemed_at_our_cash_registers_in_the_shop"]}}</span>
  </div>
  <br/><br/>

</div>
<div id="cashoutdetail_creditvoucheropenbetsCd"
     class="ui modal"
     style="width: 710px;height:310px;position:fixed;right:30%;bottom:35%;">
  <button class="circular ui icon button"
          (click)="ExitCreditVoucherModalCOb()"
          style="float:right;background-color: white;border: 1px solid;margin-top:1px;">
    <i class="remove link icon"></i>
  </button>
  <br/><br/>

  <!--<div><button class="ui circular button" (click)="ExitCreditVoucherModal()" style="float:right;">X</button></div><br /><br />-->
  <div class="content"
       style="text-align:center">
    <img src="../../../Images/creditvoucher.png"/>
  </div>
  <br/>
  <div style="text-align:center;font-size:18px;font-weight:bold;font-family:serif">
    <span>{{this.tournamentsService.translations["Bet_successfully_redeemed._Your_balance_has_been_updated"]}} </span>
  </div>
  <br/>

  <div style="text-align:center">
    <button class="ui button"
            style="background-color:orange;width:250px"
            (click)="SubmitNewBetCOb()"><span>{{"Submit_New_Bet" | t}}</span></button>
  </div>
  <br/>
  <div style="text-align:center;font-size:18px;font-weight:bold;font-family:serif">
    <span>{{this.tournamentsService.translations["You_can_withdraw_your_credit_balance_by_pressing_on_'Credit_Voucher'_in_the_upper_right_corner_and_retrieve_your_credit_voucher._that_can_be_redeemed_at_our_cash_registers_in_the_shop"]}}</span>
  </div>
  <br/><br/>

</div>
<div id="openBetsCashoutModalDetail"
     class="ui modal"
     style="position:fixed;right:30%;bottom:40%;">

  <div class="content">
    <span style="font-weight:bold;font-size:18px">{{"CASHOUT_WINNINGS_OF" | t}} {{(getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0])*(percent/100))?.toFixed(2)}}
      €? </span>
    <button class="circular ui icon button"
            style="float:right;position:relative;bottom:10px;background-color:white;border: 1px solid;"
            (click)="ObCashoutModalExitDetail()">
      <i class="remove link icon"></i>
    </button>
  </div>
  <div class="content"
       style="text-align:center">
    <button class="ui big button terminalButton"
            (click)="ObCashoutValueOkDetail((getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0])*(percent/100))?.toFixed(2))"
            style="width:150px;"><span>{{"OK" | t}}</span></button> &nbsp;&nbsp;
    <button class="ui big  button terminalButton"
            (click)="ObCashoutModalExitDetail()"
            style="width:150px;"><span>{{"CANCEL" | t}}</span></button>
  </div>
</div>


<style>

</style>

<comp_print_slip_cashout></comp_print_slip_cashout>

<iframe hidden
        style="width:274px"
        id="Slip_Cashout_PrintArea_Iframe"
        name="Slip_Cashout_PrintArea_Iframe"></iframe>

<iframe hidden
        style="width:274px"
        id="Print_Slip_Duplicate_Iframe"
        name="Print_Slip_Duplicate_Iframe"></iframe>
